import React, { useState, useEffect, useRef } from 'react';

import html2canvas from 'html2canvas';

import jsPDF from 'jspdf';

import { useDispatch, useSelector } from 'react-redux';


import HttpClient from '../../../services/httpClient';
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import { Dropdown, Select } from 'semantic-ui-react'
import { Button } from 'semantic-ui-react'
import { useTranslation } from "react-i18next";
import { finishLoading, setTitle, startLoading } from "../../../store/actions/uiAction";
import { logReportService } from '../../../services/logReportService';
import ComboHotelSala from "../../../components/combo-hotel-sala/combo-hotel-sala";
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer } from 'recharts';
import { MultiSelectComponent, CheckBoxSelection, Inject as InjectDrop } from '@syncfusion/ej2-react-dropdowns';




const GraphicsCountries = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [dateStart, setDateStart] = useState(new Date());
    const [dateEnd, setDateEnd] = useState(new Date());
    const [rowData, setRowData] = useState([]);
    const [NameSala, setNameSala] = useState([]);
    const [NameHotel, setNameHotel] = useState([]);
    const [countriesData, setCountriesData] = useState([]);

    const chartRef = useRef();

    const handleExportPDF = async () => {
        const canvas = await html2canvas(chartRef.current);
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
        pdf.addImage(imgData, 'PNG', 10, 10, 190, 80); // Ajusta tamaño/posición según tu gráfico
        pdf.save('grafica.pdf');
    };

    const animation = { enable: true, duration: 1200, delay: 100 };

    const user = useSelector(state => state.auth.currentUser);
    const { idSaleRoom, idHotel, idPais } = useSelector(state => state.user.param);
    // Estado para los años seleccionados
    const currentYear = new Date().getFullYear();
    const yearsList = Array.from({ length: currentYear - 2020 + 1 }, (_, i) => {
        const year = 2020 + i;
        return { Code: year, Name: year.toString() };
    });
    const [selectedYears, setSelectedYears] = useState([2023, 2024]);

    // Handler para cambio de años
    const onChangeYears = (e) => {
        setSelectedYears(e.value);
    };


    const toolbarOptions = ['ColumnChooser'];
    let mulObjcountries = [];
    const options = [
        { key: 'excel', icon: 'edit', text: 'Export to excel', value: 'excel' },
        { key: 'pdf', icon: 'delete', text: 'Export to pdf', value: 'pdf' },
    ]

    const checkFields = { text: 'Name', value: 'Code' };

    const onChangeDateStart = (event, data) => setDateStart(data.value);
    const onChangeDateEnd = (event, data) => setDateEnd(data.value);

    const getDataReport = (url) => {
        dispatch(startLoading());
        return new Promise((resolve, eject) => {
            HttpClient.get(url)
                .then(response => {
                    dispatch(finishLoading());
                    resolve(response);
                })
                .catch(error => {
                    dispatch(finishLoading());
                    eject(error);
                })
        });
    }

    const getData = (url, data) => {
        dispatch(startLoading());
        return new Promise((resolve, eject) => {
            HttpClient.get(url, data)
                .then(response => {
                    dispatch(finishLoading());
                    resolve(response);
                })
                .catch(error => {
                    dispatch(finishLoading());
                    eject(error);
                })
        });
    }

    const getOptionData = (url) => {
        return new Promise((resolve, eject) => {
            getData(url).then((response) => {
                if (response.status === 200) {
                    let obj = response.data;
                    let res = [];
                    for (let i in obj) {
                        let item = { Code: obj[i].id, Name: obj[i].name };
                        res.push(item)
                    }

                    resolve(res);
                }
            })
        })

    }



    const getCountriesData = () => {
        getOptionData('/catalog/paises')
            .then((response) => {
                setCountriesData(response);
            })
    }

    const handleViewButton = () => {
        getGraphicsCountries();

    }

    const primaryxAxis = { valueType: 'Category', title: 'Countries' };
    const primaryyAxis = { minimum: 0, maximum: 80, interval: 20, title: 'Medals' };

    const getGraphicsCountries = () => {

        const date1 = dateStart.toISOString().slice(0, 10).replace(/-/g, '');;
        const date2 = dateEnd.toISOString().slice(0, 10).replace(/-/g, '');;

        const idPais = (mulObjcountries != null && mulObjcountries.value.length > 0) ? mulObjcountries.value.map(String).toString() : "0";


        getDataReport(`/catalog/getNameSalavtaId/${idSaleRoom}`).then((response) => {
            if (response.status === 200) {
                setNameSala(response.data);
            }
        })

        getDataReport(`/catalog/getNameHotelId/${idHotel}`).then((response) => {
            if (response.status === 200) {
                setNameHotel(response.data);
            }
        })

        getDataReport(`/reports/country-production/${date1}/${date2}/${idSaleRoom}/${idHotel}/${idPais}`).then((response) => {
            if (response.status === 200) {
                setRowData(response.data);
                logReportService.add('Production Country', user);
            }
        })
    }





    // Fin Reporte

    useEffect(() => {
        getCountriesData();
        dispatch(setTitle(t('menusidebar.label.graphics-countries')));
    }, [])

    return (
        <div className="container-fluid">
            <ComboHotelSala />
            <div className="row col-md-12">
                <div className="col-md-12 form-group">
                    <label>{t('menusidebar.label.countries')}</label>
                    <MultiSelectComponent id="checkbox" ref={(scope) => { mulObjcountries = scope; }} dataSource={countriesData}
                        fields={checkFields} placeholder="Select type" mode="CheckBox" showSelectAll={true}
                        showDropDownIcon={true} filterBarPlaceholder="Search estatus" popupHeight="350px" value={[]}              >
                        <InjectDrop services={[CheckBoxSelection]} />
                    </MultiSelectComponent>
                </div>
                <div className="col-md-3 form-group">
                    <label >Date start:</label>
                    <SemanticDatepicker className="col-md-12" name="dateStart" value={dateStart} onChange={onChangeDateStart} />

                </div>
                <div className="col-md-3 form-group ">

                    <label >Date end:</label>
                    <SemanticDatepicker className="col-md-12" name="dateEnd" value={dateEnd} onChange={onChangeDateEnd} />

                </div>
                <div className="col-md-3 form-group">
                    <label>Años a comparar:</label>
                    <MultiSelectComponent
                        id="years-multiselect"
                        dataSource={yearsList}
                        fields={{ text: 'Name', value: 'Code' }}
                        placeholder="Selecciona años"
                        mode="CheckBox"
                        showSelectAll={true}
                        showDropDownIcon={true}
                        popupHeight="250px"
                        value={selectedYears}
                        change={onChangeYears}
                    >
                        <InjectDrop services={[CheckBoxSelection]} />
                    </MultiSelectComponent>
                </div>
                <div className="col-md-6  form-group">

                    <Button primary onClick={handleViewButton}>View Report</Button>
                    <Button positive onClick={handleExportPDF}>Descargar PDF</Button>

                </div>
            </div>
            <div >
                <div ref={chartRef}>
                    <ResponsiveContainer width="100%" height={300}>
                        <BarChart width={600} height={300} data={rowData}>
                            <XAxis dataKey="pais" stroke="#8884d8" />
                            <YAxis />
                            <Tooltip />
                            <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
                            <Bar dataKey="arrivals" fill="#888888" barSize={30} />
                            <Bar dataKey="avails" fill="#82ca9d" barSize={30} />
                        </BarChart>
                    </ResponsiveContainer>
                </div>


            </div>
        </div>
    );
}

export default GraphicsCountries;
